module.exports = __webpack_public_path__ + "img/login.6c3bade6.jpg";